export default __webpack_public_path__ + "static/media/FlatGenericTOIFullSize.df61a2f3.png";